/* eslint-disable no-console */
import { getPermaUserData } from '../../assets/js/modules/authentication';
import {
	fetchListsData,
	generatePlaceDictionary,
} from '../../assets/js/modules/listHelper';
import './ranking-card.scss';

(() => {
	const permaUserData = getPermaUserData();

	// Initial fetch and the svg text for both filled and empty heart
	// is saved in session storage
	fetch('/wp-content/themes/platea/assets/images/icon--heart.svg')
		.then((response) => response.text())
		.then((svgText) => {
			sessionStorage.setItem('emptyHeart', svgText);
		})
		.catch((error) => {
			console.error('Error fetching SVG:', error);
		});

	fetch('/wp-content/themes/platea/assets/images/icon--heart-filled.svg')
		.then((response) => response.text())
		.then((svgText) => {
			sessionStorage.setItem('filledHeart', svgText);
		})
		.catch((error) => {
			console.error('Error fetching SVG:', error);
		});

	if (permaUserData) {
		const cookieValue = JSON.parse(permaUserData);
		const apiUrl = '/wp-json/custom/v1/lists';
		const userId = cookieValue.sub;
		const getUrl = apiUrl + '?userId=' + userId;
		const savePlaceButtons = document.querySelectorAll('[data-save-place]');
		const placeList = Array.from(savePlaceButtons).map((element) => {
			return +element.getAttribute('data-save-place');
		});

		fetchListsData(getUrl).then((userLists) => {
			sessionStorage.setItem('userLists', JSON.stringify(userLists));
			generatePlaceDictionary(placeList);

			// Create an event listener for each save button to set data-place-tomodal
			// and handle icon switch logic
			savePlaceButtons.forEach((button) => {
				// When we clicked we create attribute data-place-tomodal and set the id to that
				// When clicking on a list or creating a new list, we remove that attribute
				// This observer watches over that change, and on removal, it runs the switchIcon function
				// To check if iconSwitch is necessary
				const observer = new MutationObserver(function (mutationList) {
					mutationList.forEach((mutation) => {
						switch (mutation.type) {
							case 'attributes':
								switch (mutation.attributeName) {
									case 'data-place-tomodal':
										if (
											!button.hasAttribute(
												'data-place-tomodal'
											)
										) {
											fetchListsData(getUrl).then(
												(list) => {
													sessionStorage.setItem(
														'userLists',
														JSON.stringify(list)
													);
													generatePlaceDictionary(
														placeList
													);
												}
											);
										}
										break;
								}
								break;
						}
					});
				});

				observer.observe(button, {
					attributes: true,
					attribuattributeFilter: ['data-place-tomodal'],
				});
			});
		});
	}
})(jQuery);
